import { HANDLE_HIDDEN_NAV_MENU, HANDLE_HIDDEN_REGISTER_HEADER } from '../actions.type'
import { SET_HIDDEN_NAV_MENU, SET_HIDDEN_REGISTER_HEADER } from '../mutations.type'

const state = {
  hiddenNavMenu: false,
  hiddenRegisterHeader: false
}

const getters = {
  hiddenNavMenu (state) {
    return state.hiddenNavMenu
  },
  hiddenRegisterHeader (state) {
    return state.hiddenRegisterHeader
  }
}

const actions = {
  [HANDLE_HIDDEN_NAV_MENU] (context, hiddenNavMenu) {
    context.commit(SET_HIDDEN_NAV_MENU, hiddenNavMenu)
  },
  [HANDLE_HIDDEN_REGISTER_HEADER] (context, hiddenRegisterHeader) {
    context.commit(SET_HIDDEN_REGISTER_HEADER, hiddenRegisterHeader)
  }
}

const mutations = {
  [SET_HIDDEN_NAV_MENU] (state, hiddenNavMenu) {
    state.hiddenNavMenu = hiddenNavMenu
  },
  [SET_HIDDEN_REGISTER_HEADER] (state, hiddenRegisterHeader) {
    state.hiddenRegisterHeader = hiddenRegisterHeader
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
